import apiClient from '../middleware/apiClient';
import { OT_LINES } from '../helpers/apis';
import { COTTON_OT_LINES } from '../helpers/cottonApis';
import { isCottonSession as getCottonSession } from '../helpers/featureFlags/cotton';

// Fetch OT Lines
export const GET_OT_LINES = 'GET_OT_LINES';
export const GET_OT_LINES_SUCCESS = 'GET_OT_LINES_SUCCESS';
export const GET_OT_LINES_FAILURE = 'GET_OT_LINES_FAILURE';

function dispatchGetOtLines(isCottonSession = false) {
  const endpoint = isCottonSession ? COTTON_OT_LINES : OT_LINES;
  return {
    type: GET_OT_LINES,
    payload: apiClient.fetch(endpoint),
  };
}

function dispatchGetOtLinesSuccess(otLines) {
  return {
    type: GET_OT_LINES_SUCCESS,
    payload: otLines,
  };
}

function dispatchGetOtLinesFailure(error) {
  return {
    type: GET_OT_LINES_FAILURE,
    payload: error,
  };
}

export const getOtLines = () => async (dispatch) => {
  const isCottonSession = getCottonSession();
  try {
    const response = await dispatch(dispatchGetOtLines(isCottonSession)).payload;
    return dispatch(dispatchGetOtLinesSuccess(response));
  } catch (error) {
    dispatch(dispatchGetOtLinesFailure(error));
    throw error;
  }
};
